import { createSelector } from "reselect";
import map from "lodash/map";

const getVideoId = (_, props) => props.videoId;
const getVideoEntities = (state) => state.story.entities.videos;
const getTextTrackEntities = (state) => state.story.entities.textTracks;

const makeGetTextTracks = () =>
  createSelector(
    [getTextTrackEntities, getVideoId, getVideoEntities],
    (textTrackEntities, videoId, videoEntities) => {
      const video = videoEntities[videoId];
      return map(
        video.textTracks || [],
        (trackId) => textTrackEntities[trackId],
      );
    },
  );

export default makeGetTextTracks;
